import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { first } from 'rxjs';

import { AppShellUtilitiesModule } from '@priva/appshell';
import { PrivaLocalizationService } from '@priva/localization';
import { PrivaNotificationsComponent, PrivaNotificationsService } from '@priva/notifications';
import { AppAreaService, AppAreaType } from '@priva/utilities/layout';
import { PrivaToggleModule } from '@priva/utilities/toggle';

import { preloadSettings } from 'app/features/settings/state/settings/settings.actions';
import { preloadApiConfig } from 'app/state/api-config/api-config.actions';
import { initializingBreakStore } from 'app/state/break/break.actions';
import { initializingMasterDataStore } from 'app/state/master-data/master-data.actions';
import { initializingMultiUserPreferenceStore } from 'app/state/multi-user-preferences/multi-user-preferences.actions';
import { initializeRegistrationStore } from 'app/state/registrations/registrations.actions';
import { initializeServiceWorker } from 'app/state/service-worker/service-worker.actions';
import { initializeUserSessionStore } from 'app/state/user-session/user-session.actions';

import { initializeContainerMeasurementStore } from './state/container-measurements/container-measurements.actions';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    imports: [
        AppShellUtilitiesModule,
        PrivaToggleModule,
        RouterOutlet,
        AsyncPipe,
        PrivaNotificationsComponent,
    ],
})
export class AppComponent {
    private appAreaService = inject(AppAreaService);
    privaLocalizationService = inject(PrivaLocalizationService);
    private notificationService = inject(PrivaNotificationsService);
    private store = inject(Store);

    protected readonly AppAreaType = AppAreaType;
    // Has notification bar
    hasNotificationBar$ = this.notificationService.barVisibility;
    // Has primary nav
    hasPrimaryNav$ = this.appAreaService.hasArea(AppAreaType.PrimaryNav);

    constructor() {
        this.initializeLanguageService();
        this.store.dispatch(initializeServiceWorker());
        this.store.dispatch(initializingBreakStore());
        this.store.dispatch(initializeUserSessionStore());
        this.store.dispatch(initializingMultiUserPreferenceStore());
        this.store.dispatch(preloadSettings());
        this.store.dispatch(preloadApiConfig());
        this.store.dispatch(initializingMasterDataStore());
        this.store.dispatch(initializeRegistrationStore());
        this.store.dispatch(initializeContainerMeasurementStore());
    }

    initializeLanguageService() {
        this.privaLocalizationService.language.pipe(first()).subscribe(() => {});
    }
}
